import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import LeadBlockData from '../../../Models/Content/LeadBlockData';
import Lead from './lead';
export default class LeadBlock extends EpiComponent<LeadBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['lead-block'];
    return (
      <div className={cssClasses.join(' ')}>
        <Lead iContent={this.props.data} context={this.getContext()} />
      </div>
    );
  }
}
